export enum MEMBERSHIP_TIERS {
  PUBLIC = 'PUBLIC',
  FRIENDS = 'FRIENDS',
  EVERY_HOUSE = 'EVERY_HOUSE',
  LOCAL_HOUSE = 'LOCAL_HOUSE',
  EVERY_PLUS_HOUSE = 'EVERY_PLUS_HOUSE',
  HOUSE = 'HOUSE'
}
